module.exports = __webpack_public_path__ + "static/media/img_queue.611fb5d7.jpg";